import React, { useMemo, useState } from "react";
import styles from "./TutorAvailabilityQuickApply.module.css";
import Toast from "../commoncomponent/Toast";
import {
  ALL_DAYS,
  WEEKDAYS,
  buildSlotsForDays,
  getUniqueTimeRanges,
} from "../tutorAvailabilityUtils";

const TutorAvailabilityQuickApply = ({ timeSlots = [], onApply }) => {
  const [selectedRange, setSelectedRange] = useState("");
  const timeRanges = useMemo(
    () => getUniqueTimeRanges(timeSlots),
    [timeSlots],
  );

  const handleApply = (targetDays, label) => {
    if (!selectedRange) {
      Toast.error("Please select a time slot first.");
      return;
    }

    const built = buildSlotsForDays(timeSlots, selectedRange, targetDays);
    if (!built.length) {
      Toast.error("This time slot is not available for the selected days.");
      return;
    }

    if (built.length < targetDays.length) {
      Toast.show(
        `Applied to ${built.length} of ${targetDays.length} days. Some days do not have this slot.`,
      );
    } else {
      Toast.show(`Same timing applied for ${label}.`);
    }

    onApply(built);
  };

  if (!timeRanges.length) {
    return null;
  }

  return (
    <div className={styles.quickApply}>
      <p className={styles.quickApplyTitle}>Quick apply same timing</p>
      <p className={styles.quickApplyHint}>
        Pick one time slot, then apply it to weekdays or the full week. You can
        still adjust individual days below.
      </p>
      <div className={styles.quickApplyRow}>
        <select
          className={styles.quickApplySelect}
          value={selectedRange}
          onChange={(e) => setSelectedRange(e.target.value)}
        >
          <option value="">Select time slot</option>
          {timeRanges.map((range) => (
            <option key={range.key} value={range.key}>
              {range.label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className={styles.quickApplyButton}
          onClick={() => handleApply(WEEKDAYS, "weekdays (Mon–Fri)")}
        >
          Apply to weekdays
        </button>
        <button
          type="button"
          className={styles.quickApplyButton}
          onClick={() => handleApply(ALL_DAYS, "full week (Mon–Sun)")}
        >
          Apply to full week
        </button>
      </div>
    </div>
  );
};

export default TutorAvailabilityQuickApply;
